import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';

export interface BasicInfoProps {
  username?: string;
  reference?: string;
  city: string | null;
  country: string | null;
  ip_address: string | null;
  status: LoadingState;
}

export const BasicInfo = types
  .model({
    username: types.maybe(types.string),
    reference: types.maybe(types.string),
    city: types.maybeNull(types.string),
    country: types.maybeNull(types.string),
    ip_address: types.maybeNull(types.string),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
    test: types.optional(types.string, ''),
  })
  .actions((self) => ({
    set(props: BasicInfoProps): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        ...props,
      };
      applySnapshot(self, newSnapshot);
    },
    updateStatus(status: LoadingState): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        status,
      };
      applySnapshot(self, newSnapshot);
    },
  }));

export type BasicInfoSnapshot = SnapshotIn<typeof BasicInfo>;
export type BasicInfoInstance = Instance<typeof BasicInfo>;
